import { Component, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { CountryNameService } from '../country.service';
import { ProfileService } from '../profile.service';
import { SiteSwitcherComponent } from '../site-switcher/site-switcher.component';
import { DialogFacilityComponent } from '../dialog-facility/dialog-facility.component';

@Component({
  selector: 'lib-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit, OnDestroy, OnChanges {
  editView: boolean = false;
  subscription: Subscription;
  profileName;
  profileView: boolean = true;
  @Input() drawyerData;
  userDetails: any;
  imageUrl;
  defaultuserIcon;
  @Input() profileUrl;
  @Input() sendLanguage: string = '';
  @Output() profileEvent = new EventEmitter();
  isNotHartmannUser: boolean = true;
  isGlobalAdmin: boolean = false;
  @Input() logOutUrl;
  @Input() userprinciplename;
  @Input() role: string = '';
  @Input() applicationID: string = '1';
  roleValue: string = '';
  imm;
  @Input() institutionname;
  institutionList;
  institutionNameShow: any = '';
  dataToPass: any = '';
  institutionNameLink: Array<any> = [];
  @Input() isPlatform: boolean = false;
  @Input() isDisableSetting: boolean = false;
  subscription_facility: Subscription;
  toppingsControl = new FormControl([]);
  userCountries;
  constructor(public dialog: MatDialog, 
    public translate: TranslateService, 
    private router: Router, 
    private userdetailsservice: ProfileService, 
    private apiService: ApiService, 
    private countryNameService: CountryNameService) { }

  ngOnInit() {
    this.userCountries = JSON.parse(localStorage.getItem('userObject')).userCountries;
    this.imm = this.userdetailsservice.hartmannIcon;
    /* temp value */
    this.defaultuserIcon = this.userdetailsservice.defaultuserIcon;
    this.subscription = this.userdetailsservice.completeUserData$.subscribe(res => {
      this.imageUrl = res.profileImage;
    })
    let userCountry = localStorage.getItem('countryVal');
    this.subscription_facility = this.userdetailsservice.getFacilityDetailsData$.subscribe(data => {
      if (Object.keys(data).length) {
        //this.facilityData = data;
        let selectedID = this.institutionList.find(res => (res.facilityCRMId == data.facilityCRMId && res.facilityCountry == userCountry));

        if (selectedID) {
          this.institutionList = this.institutionList.filter(res => (res.facilityCRMId != data.facilityCRMId && res.facilityCountry == userCountry))
          this.institutionList.splice(0, 0, selectedID);
          this.institutionNameShow = selectedID.facilityName;
        }
      }
    })
  }

  getCountryName(countryCode) {
    return this.countryNameService.getCountryName(countryCode);
  }

  ngOnChanges() {
    if (this.userprinciplename && !!localStorage.getItem('userObject')) {
      // this.userdetailsservice.getUpdatedLanguage.next(this.sendLanguage);
      this.userDetails = JSON.parse(localStorage.getItem('userObject'));
      this.userdetailsservice.getProfileLibData.next(this.userDetails);
      this.profileName = this.userDetails.firstName.charAt(0) + '' + this.userDetails.lastName.charAt(0);
      if (this.userDetails.profileImage && this.userDetails.profileImage != '') {
        this.imageUrl = this.userDetails.profileImage;
      }
      if (this.userDetails.accountType == 'Hartmann' || this.userDetails.accountType == 'Developer') {
        this.isNotHartmannUser = false;
      }
      if (!this.userDetails.isCountryAdmin && this.userDetails.healthPlusRoleId == '5de0138f9952be3f746353af') {
        this.isGlobalAdmin = true;
      }
      if (this.userDetails.associatedAccounts.length && this.applicationID == '1') {
        let institutions = this.userDetails.associatedAccounts;
        let userCountry = localStorage.getItem('countryVal');

        this.institutionList = institutions.filter(res => res.facilityCountry == userCountry);

        if (!!localStorage.getItem('defaultID')) {
          let selectedID = this.institutionList.find(res => (res.facilityCRMId == localStorage.getItem('defaultID') && res.facilityCountry == userCountry));
          if (selectedID) {
            this.institutionList = this.institutionList.filter(res => (res.facilityCRMId != localStorage.getItem('defaultID') && res.facilityCountry == userCountry))
            this.institutionList.splice(0, 0, selectedID);
          }

        }
        // if(this.userDetails.childFacilities.length){
        //   this.institutionList = [...this.institutionList,...this.userDetails.childFacilities];
        // }
        //this.institutionList.sort((a, b) => (a.facilityName > b.facilityName) ? 1 : -1);
        if (this.institutionList.length > 0) {
          this.institutionNameShow = this.institutionList[0].facilityName;
          localStorage.setItem('defaultID', this.institutionList[0].facilityCRMId);
        }

        //this.toppingsControl.value[0] = this.institutionList[0].facilityName;
        if (!this.institutionNameLink.length && this.institutionList.length > 0)
          this.institutionNameLink.push(this.institutionList[0].facilityName);
        var insAccount = this.institutionList.find(res => res.facilityName == this.institutionList[0].facilityName);
        this.profileEvent.emit({ event: 'loadInstitution', value: insAccount });
        this.userdetailsservice.getFacilityLoadData.next(insAccount);
        if (this.role) {
          this.userDetails.healthPlusRoleName = this.role;
        }
      }
      if (this.applicationID != '1') {
        let userCountry = localStorage.getItem('countryVal');
        this.userDetails.userAppSubscriptionDetails = this.userDetails.userAppSubscriptionDetails.filter(res => res.appId == this.applicationID && res.country == userCountry);
        if (this.userDetails.userAppSubscriptionDetails && this.userDetails.userAppSubscriptionDetails[0] != undefined) {
          if (this.userDetails.userAppSubscriptionDetails[0].facilitySubscriptionDetails.length) {
            this.institutionList = this.userDetails.userAppSubscriptionDetails[0].facilitySubscriptionDetails;
            if (!!localStorage.getItem('defaultID')) {
              let selectedID = this.institutionList.find(res => (res.facilityCRMId == localStorage.getItem('defaultID') && res.facilityCountry == userCountry));
              if (selectedID) {
                this.institutionList = this.institutionList.filter(res => (res.facilityCRMId != localStorage.getItem('defaultID') && res.facilityCountry == userCountry))
                this.institutionList.splice(0, 0, selectedID);
              }
            }
            // if(this.userDetails.childFacilities.length){
            //   this.institutionList = [...this.institutionList,...this.userDetails.childFacilities];
            // }
            if (this.institutionList.length > 0) {
              this.institutionNameShow = this.institutionList[0].facilityName;
              localStorage.setItem('defaultID', this.institutionList[0].facilityCRMId);
            }

            if (!this.institutionNameLink.length && this.institutionList.length > 0)
              this.institutionNameLink.push(this.institutionList[0].facilityName);
            var insAccount = this.institutionList.find(res => res.facilityName == this.institutionList[0].facilityName);
            this.profileEvent.emit({ event: 'loadInstitution', value: insAccount });
            this.roleValue = this.institutionList[0].facilityRoleName;
            this.userdetailsservice.getFacilityLoadData.next(insAccount);
          } else {
            this.roleValue = this.userDetails.userAppSubscriptionDetails[0].appRoleName;
          }
        }
        if (this.role) {
          this.roleValue = this.role;
        }
      }
    } else {
      this.logout();
    }
    if (this.institutionname) {
      //this.institutionList = this.institutionname;
      this.institutionNameShow = this.institutionname[0].id;

    }
  }
  insChange(e) {
    this.institutionNameLink = [];
    this.institutionNameShow = e;
    var facilityAccount = this.institutionList.find(res => res.facilityName == e);
    this.profileEvent.emit({ event: 'loadInstitution', value: facilityAccount });
    this.roleValue = facilityAccount.facilityRoleName;
    this.userdetailsservice.getFacilityLoadData.next(facilityAccount);
    localStorage.setItem('defaultID', facilityAccount.facilityCRMId);
    //this.institutionNameLink = e.source.selected._element.nativeElement.innerText.trim();
    this.institutionNameLink.push(e);
    if (this.role) {
      this.roleValue = this.role;
    }
  }
  redirectToSwitcher() {
    const dialogRefSwitch = this.dialog.open(SiteSwitcherComponent, {
      width: '550px',
      disableClose: true
    });
    dialogRefSwitch.componentInstance.facilityData = this.institutionList;
    dialogRefSwitch.afterClosed().subscribe(result => {
      if (result.event === 'facilitySelected') {
        this.insChange(result.data)
      }
    });
  }
  redirectFacility(facility) {
    let facilityId = this.institutionList.filter(ele => ele.facilityName == facility);
    const dialogRef = this.dialog.open(DialogFacilityComponent, {
      width: '900px',
      disableClose: true
    });
    this.dataToPass = {
      facilityCRM: facilityId[0].facilityCRMId,
    };
    dialogRef.componentInstance.facilityData = this.dataToPass;
    dialogRef.afterClosed().subscribe(result => {
      if (result.event === 'facilityView') {
        //this.OnUpdateProfile('');
      } else if (result.event === 'profileMoifyError') {
        //this.dataEvent.emit({ event: "profileUpdateError", value: result.message });
      }
    });
    // let facilityId = this.institutionList.filter(ele => ele.facilityName == facility);
    // this.router.navigateByUrl('/administration/institution/facility-details/'+ facilityId[0].facilityCRMId);
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscription_facility)
      this.subscription_facility.unsubscribe();
  }

  // redirect to Profile
  redirectToProfile(index) {
    // if(index == 5 && !this.isNotHartmannUser){
    //   return false;
    // }
    this.userdetailsservice.profileTabIndex.next(index);
    this.router.navigateByUrl(`/${this.profileUrl}`);
    if (this.drawyerData)
      this.drawyerData.toggle();

    this.profileEvent.emit({ event: 'submenuLinkClick' });
  }
  logout() {
    // this.userdetailsservice.logout();
    // this.profileEvent.emit({ event: 'logout'});
    // window.location.href = this.logOutUrl;

    var postParams = {
      "expires_in": localStorage.getItem('expires_in'),
      "ext_expires_in": localStorage.getItem('ext_expires_in'),
      "access_token": localStorage.getItem('access_token'),
      "refresh_token": localStorage.getItem('refresh_token'),
      "display_name": localStorage.getItem('dispName'),
      "user_principal_name": localStorage.getItem('token'),
      "user_profile_id": localStorage.getItem('user_token'),
      "jobTitle": "",
      "sessionid": localStorage.getItem('sessionId')
    };
    this.apiService.logout(postParams).subscribe(
      () => {
        localStorage.clear();
        window.location.href = this.logOutUrl;
      }, (err) => {
        localStorage.clear();
        window.location.href = this.logOutUrl;
      });
  }
}
